import { render } from "./ChildTable.vue?vue&type=template&id=67f2707a&scoped=true"
import script from "./ChildTable.vue?vue&type=script&lang=js"
export * from "./ChildTable.vue?vue&type=script&lang=js"

import "./ChildTable.vue?vue&type=style&index=0&id=67f2707a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2707a"]])

export default __exports__